/*
 *
 * MapPage reducer
 *
 */

import { fromJS } from 'immutable';
import storage from 'utils/storage';
import reduce from 'lodash/reduce';
import { TRAVELMODE_WALKING } from 'utils/directions/constants';
import { defaultMap } from 'utils/mapTypes';
import { MAP_MOVED, MAP_CHANGEDTYPE, MAP_CHANGEDMODE } from './constants';

const defaults = {
  zoom: 7,
  center: { lat: 51.5, lng: 5.3 },
  mapType: defaultMap,
  travelMode: TRAVELMODE_WALKING,
};

export const initialState = fromJS(
  reduce(
    defaults,
    (acc, val, key) => ({
      ...acc,
      [key]: storage.getItem(key) || defaults[key],
    }),
    {},
  ),
);

function mapPageReducer(state = initialState, action) {
  switch (action.type) {
    case MAP_MOVED:
      return state.set('zoom', action.zoom).set('center', action.center);
    case MAP_CHANGEDTYPE:
      return state.set('mapType', action.mapType);
    case MAP_CHANGEDMODE:
      return state.set('travelMode', action.travelMode);
    default:
      return state;
  }
}

export default mapPageReducer;
